import { W as WuiDateRangeInput$1, d as defineCustomElement$1 } from './p-xld2NRI_.js';

const WuiDateRangeInput = WuiDateRangeInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDateRangeInput, defineCustomElement };
